const SESSION_IMAGES_PAGE_SIZE = 100

export function getSessionImagesVariables(sessionId: string) {
  return {
    sessionId,
    pagination: { take: SESSION_IMAGES_PAGE_SIZE },
  }
}
